import { Sparkle } from 'lucide-react'
import { MarqueeRow } from '@/shared/ui/marquee'
import { defineT, useTranslation } from '@/shared/i18n/use-translation'

const T = defineT({
  ai: { ar: 'ذكاء اصطناعي', en: 'AI' },
  design: { ar: 'تصميم', en: 'Design' },
  code: { ar: 'برمجة', en: 'Code' },
  video: { ar: 'فيديو', en: 'Video' },
  imagery: { ar: 'صور', en: 'Imagery' },
  motion: { ar: 'موشن', en: 'Motion' },
  prompts: { ar: 'برومبتات', en: 'Prompts' },
  education: { ar: 'تعليم', en: 'Education' },
  creativity: { ar: 'إبداع', en: 'Creativity' },
})

const KEYS: Array<keyof typeof T> = [
  'ai', 'design', 'code', 'video', 'imagery', 'motion', 'prompts', 'education', 'creativity',
]

/**
 * Endless marquee of brand pillar words. Anchors the hero by giving the
 * eye somewhere to track that's not screaming for attention. Pauses on
 * hover, RTL-aware, respects reduced-motion via the underlying CSS animation.
 */
export function HeroMarquee() {
  const { t } = useTranslation(T)

  return (
    <div className="relative border-y border-border/40 bg-background/40 py-5 backdrop-blur-sm">
      <MarqueeRow durationSec={45}>
        {KEYS.map((key) => (
          <span
            key={key}
            className="inline-flex items-center gap-3 font-display text-2xl font-semibold tracking-tight text-foreground/40 sm:text-3xl"
          >
            <Sparkle className="h-4 w-4 text-primary" aria-hidden />
            {t(key)}
          </span>
        ))}
      </MarqueeRow>
    </div>
  )
}
